"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultMessageState = void 0;
exports.defaultMessageState = {
    message: '',
    active: false,
    warningLevel: 0,
};
